import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

const loadingManager = new THREE.LoadingManager();

const loaderText = document.getElementById('loader-text');
const loaderDiv = document.getElementById('loader');

loadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
    const percent = Math.floor((itemsLoaded / itemsTotal) * 100);
    loaderText.innerText = percent + '%';
};

loadingManager.onLoad = () => {
    loaderDiv.style.display = 'none';
};

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

const gltfLoader = new GLTFLoader(loadingManager)


gltfLoader.load(
    './models/round_wooden_table_01_1k/round_wooden_table_01_1k.gltf',
    (gltf) =>
    {
        gltf.scene.traverse( (child) => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });

        scene.add(gltf.scene,)
    }
)

gltfLoader.load(
    './models/mid_century_lounge_chair_1k/mid_century_lounge_chair_1k.gltf',
    (gltf) =>
    {
        const clone1 = gltf.scene.clone(true)

        gltf.scene.position.set(1, 0, 0)
        gltf.scene.rotation.set(0, -Math.PI/2, 0)

        gltf.scene.traverse( (child) => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });

        scene.add(gltf.scene)

        clone1.position.set(-1, 0, 0)
        clone1.rotation.set(0, Math.PI/2, 0)

        clone1.traverse( (child) => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });
        scene.add(clone1)
    }
)

gltfLoader.load(
    './models/chess_set_1k/chess_set_1k.gltf',
    (gltf) =>
    {
        gltf.scene.position.y = 1
        gltf.scene.rotation.set(0, -Math.PI/2, 0)

        gltf.scene.traverse( (child) => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });


        scene.add(gltf.scene)
    }
)

gltfLoader.load(
    './models/desk_lamp_arm_01_1k/desk_lamp_arm_01_1k.gltf',
    (gltf) =>
    {
        gltf.scene.position.y = 1.005
        gltf.scene.position.z = -0.655
        gltf.scene.position.x = -0.2
        gltf.scene.rotation.set(0, Math.PI, 0)
        gltf.scene.traverse( (child) => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });

        scene.add(gltf.scene)
    }
)

gltfLoader.load(
    './models/mantel_clock_01_1k/mantel_clock_01_1k.gltf',
    (gltf) =>
    {
        gltf.scene.position.y = 1
        gltf.scene.position.z = 0.5
        gltf.scene.position.x = 0
        gltf.scene.rotation.set(0, -Math.PI, 0)

        gltf.scene.traverse( (child) => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });

        scene.add(gltf.scene)
    }
)

gltfLoader.load(
    './models/brass_goblets_1k/brass_goblets_1k.gltf',
    (gltf) =>
    {
        const goblet1 = gltf.scene.children[0]
        const goblet2 = gltf.scene.children[1]

        goblet1.position.y = 1
        goblet1.position.z = -0.3
        goblet1.position.x = 0.4

        goblet2.position.y = 1
        goblet2.position.z = -0.43
        goblet2.position.x = -0.3

        goblet1.traverse( (child) => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });

        goblet2.traverse( (child) => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });

        scene.add(goblet1, goblet2)
    }
)

gltfLoader.load(
    './models/brass_vase_02_1k/brass_vase_02_1k.gltf',
    (gltf) =>
    {
        gltf.scene.position.y = 1
        gltf.scene.position.z = -0.55
        gltf.scene.position.x = 0.2
        gltf.scene.rotation.set(0, -Math.PI, 0)

        gltf.scene.traverse( (child) => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });

        scene.add(gltf.scene)
    }
)


const ambientLight = new THREE.AmbientLight(0xffffff, 0.1)
scene.add(ambientLight)


const spotLight = new THREE.SpotLight(0xffffff, 2.61);
spotLight.position.set(-0.183, 1.711, -0.469);
spotLight.angle = 1.47;  // узкий конус
spotLight.penumbra = 1;
spotLight.castShadow = true;

scene.add(spotLight);

const textureLoader = new THREE.TextureLoader(loadingManager)
const ColorTexture = textureLoader.load('./floor/black_painted_planks_diff_2k.png')
const ARMTexture = textureLoader.load('./floor/black_painted_planks_arm_2k.png')
const NormalTexture = textureLoader.load('./floor/black_painted_planks_nor_gl_2k.png')
const DisplacementTexture = textureLoader.load('./floor/black_painted_planks_disp_2k.png')


ARMTexture.repeat.set(8, 8)
ColorTexture.repeat.set(8, 8)
NormalTexture.repeat.set(8, 8)
DisplacementTexture.repeat.set(8, 8)

ARMTexture.wrapS = THREE.RepeatWrapping
ColorTexture.wrapS = THREE.RepeatWrapping
NormalTexture.wrapS = THREE.RepeatWrapping
DisplacementTexture.wrapS = THREE.RepeatWrapping

ARMTexture.wrapT = THREE.RepeatWrapping
ColorTexture.wrapT = THREE.RepeatWrapping
NormalTexture.wrapT = THREE.RepeatWrapping
DisplacementTexture.wrapT = THREE.RepeatWrapping

ColorTexture.colorSpace = THREE.SRGBColorSpace

const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(10, 10),
    new THREE.MeshStandardMaterial({
        map: ColorTexture,
        aoMap: ARMTexture,
        roughnessMap: ARMTexture,
        metalnessMap: ARMTexture,
        normalMap: NormalTexture,
        displacementMap: DisplacementTexture,
        displacementScale: 0.05,
        displacementBias: -0.01
    })
)
floor.receiveShadow = true
floor.rotation.x = - Math.PI * 0.5
scene.add(floor)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(2, 2, 2)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.target.set(0, 0.75, 0)
controls.enableDamping = true

controls.minDistance = 2
controls.maxDistance = 5
controls.maxPolarAngle = Math.PI / 2;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()